module.exports = __webpack_public_path__ + "static/media/stream_switch_video_classes.84f208e7.svg";